import { EmptyStateProcessIllustration, Button } from "@octopusdeploy/design-system-components";
import type { GitRef } from "@octopusdeploy/octopus-server-client";
import { links } from "@octopusdeploy/portal-routes";
import * as React from "react";
import ActionList from "~/components/ActionList/ActionList";
import OnboardingPage from "~/components/GettingStarted/OnboardingPage";
interface OnboardingProps {
    slug: string;
    gitRef: GitRef | undefined;
}
const ProcessTemplateOnboarding = ({ slug, gitRef }: OnboardingProps) => {
    const createProcessHref = links.editProcessTemplatePage.generateUrl({ slug }, { gitRef, stepTemplates: true });
    return (<OnboardingPage title="Create your process template" intro={`The process template is a group of steps that are reusable across any project`} learnMore={<></>} image={<EmptyStateProcessIllustration />} actionButtons={<ActionList alignStart={true} actions={[<Button label={"Create Process"} href={createProcessHref} importance="primary"/>]}/>}/>);
};
export default ProcessTemplateOnboarding;
